import {
  readCachedCreatorPublicSurface,
} from "./url/creatorPublicSurface";

/** LiB feed/search is embedded under `.mte-tpl-page` on `/website` and dashboard Website tab. */
export function isInsideWebsiteTemplatePage(): boolean {
  if (typeof document === "undefined") return false;
  return Boolean(document.querySelector(".mte-tpl-page"));
}

function usernameFromPublicPath(pathname: string): string | null {
  const website = pathname.match(/^\/website\/([^/?#]+)/i);
  if (website?.[1]) {
    try {
      return decodeURIComponent(website[1]).trim().toLowerCase();
    } catch {
      return website[1].trim().toLowerCase();
    }
  }
  const bare = pathname.match(/^\/([^/?#]+)(?:\/|$)/i);
  if (!bare?.[1]) return null;
  try {
    return decodeURIComponent(bare[1]).trim().toLowerCase();
  } catch {
    return bare[1].trim().toLowerCase();
  }
}

/** Public browsable site only — excludes dashboard editor preview. */
export function isPublicWebsiteTemplateRoute(pathname?: string): boolean {
  const p =
    pathname ??
    (typeof window !== "undefined" ? window.location.pathname : "");
  if (/^\/website\/[^/?#]+/i.test(p)) return true;

  // Dedicated website shop collection URLs (`/:username/shop/collections/:id`).
  if (/(?:^|\/)shop\/collections\/[^/]+/i.test(p)) return true;

  const user = usernameFromPublicPath(p);
  if (!user || readCachedCreatorPublicSurface(user) !== "website") return false;

  // Canonical `/{username}` or any nested path under that creator.
  return /^\/[^/?#]+(?:\/|$)/i.test(p);
}
